import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SshComponent} from './components/ssh/ssh.component';

const routes: Routes = [
    {
        path: '',
        component: SshComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SshRoutingModule {
}
